import { useFetchAllTextMaterialThemes } from '@@partner:graphql/query/textMaterial/themes/allTextMaterialThemes.gql'
import { GQL_ID } from '@@partner:types:graphql'
import React from 'react'
import { CheckPicker } from 'rsuite'

type ThemeCheckPickerProps = {
  value: GQL_ID[]
  onChange: (value: GQL_ID[]) => void
}

export default function ThemeCheckPicker ({
  value,
  onChange
}: ThemeCheckPickerProps) {
  
  const { data, loading, error, refetch } = useFetchAllTextMaterialThemes({
    pager: {
      page: 1,
      limit: 100
    },
    sort: {
      fieldName: 'updated_at',
      direction: 0
    }
  })

  const themesOptions = data?.allTextMaterialThemes?.edges.map((theme) => ({
    label: theme.name,
    value: theme.id
  })) ?? []


  return (
    <CheckPicker
      data={themesOptions}
      value={value}
      onChange={onChange}
      placeholder="Выберите темы"
      style={{ width: '100%' }}
      block
    />
  )
}